import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

export function getContext() {
    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                staleTime: 60_000,
            },
        },
    });
    return { queryClient };
}

export function Provider({
    children,
    queryClient,
}: {
    children: React.ReactNode;
    queryClient: QueryClient;
}) {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
